import { reactive } from 'vue'

/**
 * The confirmation the requests listing shows before turning the picked requests into
 * work orders - how many were picked, and what to do once the user confirms a start
 * time for them.
 */
export function useConvertDialog () {
  const state = reactive({
    isOpen: false,
    requestCount: 0,
    onConfirm: null
  })

  const open = (config) => {
    const { requestCount, onConfirm } = config || {}
    state.requestCount = Number(requestCount) || 0
    state.onConfirm = onConfirm || null
    state.isOpen = true
  }

  const close = () => {
    state.isOpen = false
    state.requestCount = 0
    state.onConfirm = null
  }

  return {
    state,
    open,
    close
  }
}
